(() => {
  /**
   * Loader class for handling the loading of external scripts.
   */
  class Loader {
    /**
     * Constructor for the Loader class.
     * 
     * @param {Object} options - The options for the Loader.
     */
    constructor(options) {
      this.defaults = {
        src: 'https://static.rechargecdn.com/assets/storefront/recharge-client-1.29.0.min.js',
      }
      this.options = Object.assign({}, this.defaults, options);
      this.session = null;
    }

    /**
     * Checks if the script is already loaded.
     * 
     * @returns {boolean} True if the script is loaded, otherwise false.
     */
    isLoaded() {
      let scripts = document.head.querySelectorAll('script');
      let find = [...scripts].find(s => {
        return s.getAttribute('src') === this.options.src;
      });
      return Boolean(find);
    }

    /**
     * Loads the script.
     * 
     * @returns {Promise} A promise that resolves when the script is loaded, or rejects if there is an error.
     */
    load() {
      return new Promise((resolve, reject) => {
        if (this.isLoaded()) {
          return reject('Recharge Client script is already loaded.');
        }
        let s = document.createElement('script');
        s.defer = true;
        s.src = this.options.src;
        s.addEventListener('load', () => {
          return resolve(true);
        });
        s.addEventListener('error', () => {
          return reject('There\'s an issue loading the script.');
        });
        document.head.appendChild(s);
      })
    }
  }

  /**
   * Starts the loading of the Recharge Client script.
   */
  const start = async () => {
    window.Shopify.Recharge.Loader = new Loader();
    try {
      await window.Shopify.Recharge.Loader.load();
      if (window?.recharge) {
        window.recharge.init({
          storeIdentifier: window.Shopify.shop
        });
        window.Shopify.Recharge.Loader.session = await recharge.auth.loginShopifyAppProxy();
        document.dispatchEvent(new CustomEvent('Recharge:Client:Loaded'));
      }
    } catch {
      console.error('There\'s an issue loading the Recharge Client script.');
    }
  };

  (window.Shopify = window.Shopify || {}).Recharge = {};

  // Start the loading of the Recharge Client script when the document is ready
  if (document.readyState !== 'loading') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }

})();
